import { ReactNode } from "react";

interface GenericStringObject {
  key: string;
  value?: string;
}

interface UniversalExpanderDataColumnProps {
  title: string;
  data: GenericStringObject[];
  subtitle?: ReactNode | string;
}

export const UniversalExpanderDataColumn = ({
  title,
  data,
  subtitle
}: UniversalExpanderDataColumnProps) => {
  return (
    <div className="pb-6">
      <div className="pb-2 border-b border-alpha-40">
        <p className="text-sm font-medium text-content-1000">{title}</p>
      </div>
      {subtitle ? (
        <p className="text-sm text-content-300 my-3">{subtitle}</p>
      ) : null}
      <div className="mt-3 flex flex-col gap-3">
        {data.map((item) => {
          return (
            <div className="flex text-sm font-medium gap-6" key={item.key}>
              <p className="min-w-fit w-full max-w-[180px] text-content-300 whitespace-pre-wrap">
                {item.key}
              </p>
              <p className="text-content-1000 whitespace-pre-wrap">
                {item.value || "-"}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
